import { useState } from "react";
import './index.css';
import titleImg from './assets/gatwif.png';
import divider from './assets/divider.png';

function App() {

  const contract = "9ENyp2YoHq55ny2ARnjybKT8KHLZXF2KMYjpTXmApump";
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contract);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  return (
    <div className="hero d-flex flex-column justify-content-start align-items-center">

      <div className="container">
        <div className="row justify-content-start">
          <div className="col-lg-6 col-md-6">

            {/* CARD */}
            <div className="hero-card text-center">

              <img src={titleImg} alt="" className="hero-title-img" />

              <div className="hero-sub">
                A NEW ERA. A NEW WIF
              </div>

              <img src={divider} alt="" className="divider-img" />

              <p className="hero-text">
                It’s more than a meme.<br />
                It’s movement for those who choose the future.
              </p>

            </div>

          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6">
            {/* CONTRACT */}
            <div className="contract-bar">
              {/* <span>{contract.slice(0, 6)}...{contract.slice(-6)}</span> */}
              <p className='d-flex justify-content-center align-items-center flex-wrap m-0'>

                <span className="contract-label">Contract: &nbsp;</span>

                <span className='d-block d-sm-none'>
                  {contract.slice(0, 8)}...{contract.slice(-8)}
                </span>

                <span className='d-none d-sm-block'>
                  {contract}
                </span>

                {/* FIXED PART */}
                <span className="copy-wrapper ms-2">

                  <span className="copy-btn" onClick={copyToClipboard}>
                    <i className="fa-solid fa-copy"></i>
                  </span>

                  {copied && <span className="copy-tooltip">Copied!</span>}

                </span>

              </p>
            </div>

          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6">
            {/* BUTTONS */}
            <div className="bottom-actions">

              <div className="d-flex flex-wrap justify-content-center align-items-center gap-4">
                <button className="btn-buy"><a href="https://jup.ag/?sell=9ENyp2YoHq55ny2ARnjybKT8KHLZXF2KMYjpTXmApump" target="_blank" rel="noopener noreferrer">BUY</a></button>
                <button className="btn-chart"><a href="https://dexscreener.com/solana/9enyp2yohq55ny2arnjybkt8khlzxf2kmyjptxmapump" target="_blank" rel="noopener noreferrer">CHART</a></button>
                <br className='d-none d-sm-block' />
                <a href="https://t.me/GatWifDog" target="_blank" rel="noreferrer" className="icon-btn">
                  <i className="fa-solid fa-paper-plane"></i>
                </a>
                <a href="https://x.com/GatWifDog" target="_blank" rel="noreferrer" className="icon-btn">
                  <i className="fa-brands fa-x-twitter"></i>
                </a>
              </div>

            </div>
            <div className="copyright text-center mt-4"><span>© 2026 GATWIF All Rights Reserved. Email: <a href="mailto:gat@gatwif.xyz">gat@gatwif.xyz</a></span></div>
          </div>
        </div>
      </div>




    </div>
  );
}

export default App;